import React from 'react';

// local dependencies
import { MemberAddEditPaymentInformation } from 'ui/containers/MemberAddEditPaymentInformation';
import { memberAddEditAddresspreloader as MemberAddEditAddresspreloader } from 'ui/views/widgets/memberAddEditAddress';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { Icon } from 'modules/icon-bank';

// success view
const memberInfoSettingPaymentInfoSuccess = ( props ) => {
    const { showCustomErrorView = false, description } = props;

    if( showCustomErrorView ) {
		return (
			<div className="ui-member-payment-settings-info-default">
 				<div className='ui-member-payment-settings-info-default__icon'>
                    <Icon name='warningBlue' width={ 50 } height={ 50 } />
                </div>

				{/* sub-title */}
                <p className='ui-member-payment-settings-info-default__title'>
                    { description }
                </p>

		</div>
		);
    }
    
    return (
        <div className='ui-member-info-setting-payment-info'>
            <MemberAddEditPaymentInformation
                displayTitle={ false }
                enableSelection={ false }
                defaultDescription= { props.defaultDescription }
                
                //widgetConfig= { props.widgetConfig }
                { ...props }
            />
        </div>
    );
};

// set display name
memberInfoSettingPaymentInfoSuccess.displayName = 'memberInfoSettingPaymentInfoSuccess';

// set default props
memberInfoSettingPaymentInfoSuccess.defaultProps = {};

// prop types
memberInfoSettingPaymentInfoSuccess.propTypes = {};

/*******************************************************/

/**---------------------------- */

// Preloader
const memberInfoSettingPaymentInfoPreloader = ( ) => {
    return (
        <div className='ui-member-info-communication-settings-preloader'>
            <MemberAddEditAddresspreloader hideTitle={ true } />
        </div>
    );
};

// set display name
memberInfoSettingPaymentInfoPreloader.displayName = 'memberInfoSettingPaymentInfoPreloader';

// set default props
memberInfoSettingPaymentInfoPreloader.defaultProps = {};

// prop types
memberInfoSettingPaymentInfoPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberInfoSettingPaymentInfo as MemberInfoSettingPaymentInfo } from 'ui/views/widgets/memberInfoSettingPaymentInfo';
 *
 * // render
 * <MemberInfoSettingPaymentInfo propName='propValue'/>
 */
export const memberInfoSettingPaymentInfo = withNetworkState( memberInfoSettingPaymentInfoPreloader, memberInfoSettingPaymentInfoSuccess );
